<template>
  <v-app-bar
    app
    prominent
    color="#fcb69f"
    dark
    src="https://haikubox-images.s3.amazonaws.com/web/birdSinging3.jpeg"
    shrink-on-scroll
  >
    
   <v-toolbar-title class="mx-2" style="cursor: pointer" @click="goToHaikuboxDotCom()">HAIKUBOX
    </v-toolbar-title>
    

    <v-spacer></v-spacer>

    <v-btn class="mx-2" @click="signUp()">Sign Up</v-btn>

    <v-btn @click="signIn()">Sign In </v-btn>
    <v-btn icon v-tooltip.bottom-start="'Help'" :href="'https://haikubox.com/support-haikubox'" target="_blank">
      <v-icon alt="help">mdi-help-circle-outline</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
export default {
  props: {},
  methods: {
    signIn() {
      this.$emit("signIn");
    },
    signUp() {
      this.$emit("signUp");
    },
    goToHaikuboxDotCom(){
      // console.log("open haikubox.com");
      window.location.href = 'https://haikubox.com';
    },
  },
};
</script>
